export default {
  Chat: {
    width: 350
  },
  GameCard: {
    gutterSize: 30,
    height: 180,
    width: 140
  },
  NavBar: {
    height: '50px'
  },
  StreamCard: {
    gutterSize: 30,
    height: 180,
    width: 300
  }
};
